/** @format */

import React from 'react'
import { _$, Card } from '@king-design/react'
import styled from 'styled-components'
import { CustomPageContainer } from 'src/components'
import AlarmSilences from 'src/containers/MonitorAlarmSilences'

const MonitorAlarmSilences: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={className}>
      <CustomPageContainer title={_$('告警屏蔽')}>
        <Card type="none">
          <AlarmSilences />
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(MonitorAlarmSilences)``
